export const DataHooks = {
  Root: 'App.Root',
  EmptyState: 'App.EmptyState',
} as const;
